import React from 'react';
import GroupStat from '../GroupStat';
import CommentStat from '../CommentStat';
import ShareStat from '../ShareStat';
import LoveStat from '../LoveStat';
import FavouriteStat from '../FavouriteStat';
import DownloadStat from '../DownloadStat';
import PcpStat from '../PcpStat';
import { useDeviationAttributes } from '../hooks/useDeviationAttributes';
export var PrimaryActionBarIcons = function (_a) {
    var isOwner = _a.isOwner, deviation = _a.deviation;
    var _b = useDeviationAttributes(deviation, isOwner), isLoveable = _b.isLoveable, isDownloadable = _b.isDownloadable, isPurchasable = _b.isPurchasable, isCommentable = _b.isCommentable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isShareable = _b.isShareable;
    return (React.createElement(React.Fragment, null,
        isLoveable && React.createElement(LoveStat, { isOwner: isOwner, deviation: deviation }),
        isCommentable && React.createElement(CommentStat, { deviation: deviation }),
        isFavouritable && (React.createElement(FavouriteStat, { isOwner: isOwner, deviation: deviation, actionBarType: "primary" })),
        isGroupSubmittable && (React.createElement(GroupStat, { deviation: deviation, actionBarType: "primary" })),
        isDownloadable && React.createElement(DownloadStat, { deviation: deviation }),
        isPurchasable && React.createElement(PcpStat, { isOwner: isOwner, deviation: deviation }),
        isShareable && React.createElement(ShareStat, { deviation: deviation })));
};
PrimaryActionBarIcons.displayName = 'PrimaryActionBarIcons';
export default PrimaryActionBarIcons;
//# sourceMappingURL=PrimaryActionBarIcons.js.map